import { HasShellContext } from "@insite/client-framework/Components/IsInShell";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { useEffect, useState } from "react";

const enum fields {
    jsRunLocation = "jsRunLocation",
    jsScriptSrc = "jsScriptSrc",
    jsScriptCode = "jsScriptCode",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.jsRunLocation]: string;
        [fields.jsScriptSrc]: string;
        [fields.jsScriptCode]: string;
    };
}

type Props = OwnProps & HasShellContext;

export const InsertDynamicJsScript = ({ fields, shellContext }: Props) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const dynamicScriptId = "DynamicScript";
    const jsRunLocation = fields.jsRunLocation;
    const jsScriptSrc = fields.jsScriptSrc;
    const jsScriptCode = fields.jsScriptCode;
   
    useEffect(() => {
        if (!document.getElementById(dynamicScriptId) && window.location.pathname.includes(jsRunLocation)) {
            loadScript();
        } else {
            setIsLoaded(false);
        }
        return () => {
            const element = document.getElementById(dynamicScriptId);
            if (element) {
                document.head.removeChild(element as Node);
            }
        };
    }, [jsScriptCode, jsScriptSrc]);


    const loadScript = () => {
        const s = document.createElement("script");
        s.id = dynamicScriptId;
        s.type = "text/javascript";
        s.src = jsScriptSrc;
        s.async = true;
        s.defer = true;
        s.innerHTML = jsScriptCode;        
        s.onload = () => setIsLoaded(true);
        document.head.appendChild(s);
    };

    return <></>;
};

const definition: WidgetDefinition = {
    group: "Basic",
    fieldDefinitions: [
        {
            fieldType: "General",
            name: fields.jsRunLocation,
            editorTemplate: "TextField",
            displayName: "Run Location Contains",
            defaultValue: "/chambers-configurator",
        },
        {
            fieldType: "General",
            name: fields.jsScriptSrc,
            editorTemplate: "TextField",
            displayName: "JavaScript Src",
            defaultValue: "https://res.cloudinary.com/iwh/raw/upload/v1739976243/chmcfg.bundle_i9akfw.js",
        },
        {
            fieldType: "General",
            name: fields.jsScriptCode,
            editorTemplate: "TextField",
            displayName: "JavaScript Code",
            defaultValue: "",
        },
    ],
};

const widgetModule: WidgetModule = {
    component: InsertDynamicJsScript,
    definition,
};

export default widgetModule;
